/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export type NotificationModal = {
    isOpen: boolean;
    notificationId?: string;
};

const initialNotificationModalState: NotificationModal = {
    isOpen: false,
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        addNotificationModal: initialNotificationModalState,
        isEmergencyContactNotificationModalOpen: false,
        isRedSwitchOn: true,
    },
    reducers: {
        setEmergencyContactNotificationModalState: (state, { payload }: PayloadAction<boolean>) => {
            state.isEmergencyContactNotificationModalOpen = payload;
        },
        addNotificationModal: (state, { payload }: PayloadAction<NotificationModal>) => {
            state.addNotificationModal = payload;
        },
        toggleRedSwitch: (state, { payload }: PayloadAction<boolean>) => {
            state.isRedSwitchOn = payload;
        },
    },
});

export default notificationSlice;
export const { addNotificationModal, toggleRedSwitch, setEmergencyContactNotificationModalState } =
    notificationSlice.actions;

export const selectAddNotificationModal = (state: RootState): NotificationModal =>
    state.notification.addNotificationModal;

export const selectEmergencyContactNotificationModalState = (state: RootState): boolean =>
    state.notification.isEmergencyContactNotificationModalOpen;

export const selectRedSwitchState = (state: RootState): boolean => state.notification.isRedSwitchOn;
